module.exports = __webpack_public_path__ + "img/sp_03.5410575f.png";